import { render, staticRenderFns } from "./main.vue?vue&type=template&id=6b3468a8"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=6b3468a8&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b3468a8')) {
      api.createRecord('6b3468a8', component.options)
    } else {
      api.reload('6b3468a8', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=6b3468a8", function () {
      api.rerender('6b3468a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/affix/main.vue"
export default component.exports